export default "__VITE_ASSET__DPVGWZ$A__"